




































































































































































import {
  AccountTypeEnum, PartyModel,
  RepeatFrequencyEnum, TenantModel,
  TenantUserModel,
  VisitRuleModel,
  VisitRuleWorkTaskModel, WorkTaskRuleModel
} from '@/libs/Api';
import Page from '@/Page.vue';
import {Guid} from '@/libs/common/functions/guid';
import {Component, Ref, Watch} from 'vue-property-decorator';
import {visitRulesStore} from '@/libs/visit-rules/+state/store';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {Constants} from "@/constants";
import moment from 'moment';
import {tenantsStore} from "@/libs/tenants/+state/store";
import {CrudGetter} from "@/libs/core/+state/models/crud-getter";
import {partiesStore} from "@/libs/parties/+state/store";

@Component({
    computed: {
        Constants() {
            return Constants
        },
        RepeatFrequencyEnum() {
            return RepeatFrequencyEnum
        }
    }
})
export default class VisitPlanDialog extends Page {

    dialog = false;
    deleteDialog = false;
    unsavedDialog = false;
    valid = true;
    saving = false;
    deleting = false;
    item: VisitRuleModel | null = null;
    basicRules = [
        (v: any) => !!v || this.translate('validation.thisFieldIsRequired')
    ];
    guid = Guid;
    newId = Guid.EmptyGuid();
    partyId: string | null = null;
    selectParty = false;

    get isNewItem() : boolean {
        return this.item?.id == Guid.EmptyGuid();
    }
    
    get readonly (): boolean {
      const tenantId = authStore.useGetter(AuthGetter.GetTenant);
      const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
      const tenant = tenantsStore.useGetter(CrudGetter.Detail, tenantId) as TenantModel;
      const party = partiesStore.useGetter(CrudGetter.Detail) as PartyModel;
      const enableWorkTaskRuleCreate = tenantUser.accountType == AccountTypeEnum.Admin || tenantUser.accountType == AccountTypeEnum.Manager || (tenantUser.accountType == AccountTypeEnum.Worker && tenant.enableCreateWorkTaskRuleByWorker == true);
      if (!enableWorkTaskRuleCreate) {
        return true;
      }
      if (tenantUser.accountType == AccountTypeEnum.Volunteer) {
        return true;
      }
      else if (tenantUser.accountType == AccountTypeEnum.Worker) {
        if (tenant.enableEditClientByWorker && party.mainCareProviderId == tenantUser.userId) {
          return false;
        }
        else if (tenant.enableEditClientOfAnotherWorkers && party.districtId == tenantUser.mainDistrictId) {
          return false;
        }
        else {
          return true;
        }
      }
      return false;
    }

	hasWorkTasks(): boolean {
		console.log(this.item?.visitRuleWorkTasks);
		return this.item?.visitRuleWorkTasks?.any(x => x.workTaskRuleId !== undefined && x.workTaskRuleId != null && x.workTaskRuleId != Guid.EmptyGuid()) ?? false;
	}

    @Watch("dialog")
    dialogChanged(v: boolean) {
        if (!v)
            this.close();
    }

    @Ref() form!: any;

    load(id: string | null) {
        if (id == null || id == Guid.EmptyGuid()) {
            this.item = {
                id: Guid.EmptyGuid(),
                name: "",
                repeatEach: 1,
                repeatFrequency: RepeatFrequencyEnum.Week,
                onMonday: true,
                onTuesday: false,
                onThursday: false,
                onWednesday: false,
                onFriday: false,
                onSaturday: false,
                onSunday: false,
                dayOccurrence: 1,
                fromTime: '',
                toTime: '',
                nextBusinessDayOnHoliday: false,
                description: null,
                visitRuleWorkTasks: [
                    {
                        visitRuleId: Guid.EmptyGuid(),
                        workTaskRuleId: Guid.EmptyGuid(),
                        description: null
                    }
                ],
                partyId: this.partyId!
            };
        }
        else {
            visitRulesStore.dispatch(CrudAction.Get, { id: id });
            this.subscribe(visitRulesStore, CrudReponse.Get).then((e: VisitRuleModel) => {
                this.item = e;
            });
        }
    }

    open (id: string | null = null, partyId: string | null = null) {
        this.dialog = true;
        this.partyId = partyId;
        this.selectParty = partyId == null;
        this.load(id);
    }

    close () {
        this.dialog = false;
    }

    save () {
        if (this.form.validate()) {
            this.saving = true;
	        this.item!.visitRuleWorkTasks = this.item?.visitRuleWorkTasks?.where(x => x.workTaskRuleId !== undefined && x.workTaskRuleId != null && x.workTaskRuleId != Guid.EmptyGuid()).toArray() ?? [];
            if (this.item!.id == Guid.EmptyGuid()) {
                visitRulesStore.dispatch(CrudAction.Create, { item: this.item });
                this.subscribe(visitRulesStore, CrudReponse.Create).then((e: VisitRuleModel) => {
                    this.saving = false;
                    this.close();
                    const tenantId = authStore.useGetter(AuthGetter.GetTenant);
                    this.item = e;
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
            else {
                visitRulesStore.dispatch(CrudAction.Update, { item: this.item });
                this.subscribe(visitRulesStore, CrudReponse.Update).then((e: VisitRuleModel) => {
                    this.saving = false;
                    this.close();
                }).catch((e: any) => {
                    this.saving = false;
                });
            }
        }
    }

    addWorkTask() {
        this.item?.visitRuleWorkTasks!.push({
            visitRuleId: Guid.EmptyGuid(),
            workTaskRuleId: Guid.EmptyGuid(),
            workTaskRule: undefined,
            description: null
        });
    }

    deleteWorkTask(item: VisitRuleWorkTaskModel) {
        this.item?.visitRuleWorkTasks!.splice(this.item?.visitRuleWorkTasks!.indexOf(item), 1);
    }

    deleteItemClick() {
        this.deleteDialog = true;
    }

    deleteItem () {
        this.deleting = true;
        visitRulesStore.dispatch(CrudAction.Delete, { id: this.item!.id });
        this.subscribe(visitRulesStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.$emit("changed");
            this.dialog = false;
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

  getExcept(id: string | null): string[] {
      return this.item!.visitRuleWorkTasks!.where(x => x.workTaskRuleId != id).select(x => x.workTaskRuleId ?? Guid.EmptyGuid()).toArray();
  }
    
    isNewId(id: string | undefined) {
        return !id || id == Guid.EmptyGuid();
    }
    
    partyChanged(partyId: string | null) {
      this.item!.visitRuleWorkTasks = [
        {
          visitRuleId: Guid.EmptyGuid(),
          workTaskRuleId: Guid.EmptyGuid(),
          description: null
        }
      ];
    }
    
    repeatFrequencyChanged() {
        if (this.item?.repeatFrequency == RepeatFrequencyEnum.Month) {
            this.item!.repeatEach = 1;
        }
    }
    
    isIntervalsOverlay(workTaskRule: WorkTaskRuleModel) {
        const maxDate = new Date(8640000000000000);
        const minDate = new Date(-8640000000000000);
        const visitInterval = {
            fromDate: this.item?.startDate ? moment(this.item!.startDate).toDate() : minDate,
            toDate: this.item?.endDate ? moment(this.item!.endDate).toDate() : maxDate,
        };
        const ruleInterval = {
            fromDate: workTaskRule?.startDate ? moment(workTaskRule!.startDate).toDate() : minDate,
            toDate: workTaskRule?.endDate ? moment(workTaskRule!.endDate).toDate() : maxDate,
        }
        return visitInterval.fromDate < ruleInterval.toDate && visitInterval.toDate > ruleInterval.fromDate;
    }

}
